import React, { useEffect } from "react";
import "./Doctor_Rating.css";
import Average_Rating from "./average_Rating/Average_Rating";
import Submit_Your_Review from "./submit_Your_Review/Submit_Your_Review";
import Customer_Feedbacks from "./customer_Feedbacks/Customer_Feedbacks";
import { useDispatch, useSelector } from "react-redux";
import { allDoctorRating } from "../../../../features/doctor_rating/doctor_ratingSlice";

function Doctor_Rating({ doctor, avg_rating }) {
  const dispatch = useDispatch();
  const all_rating = useSelector((state) => state.doctorRating.all_rating);

  useEffect(() => {
    dispatch(
      allDoctorRating({
        doctor_id: doctor.id,
      }),
    );
  }, [dispatch, doctor]);

  return (
    <>
      <section className="Doctor_Rating">
        <div className="heading_holder text-center">
          <h4 className="heading_text">Reviews</h4>
        </div>
        <div className="">
          <div className="Doctor_Rating_container"> 
            <div className="row">
              <div className="col-lg-12">
                <Average_Rating doctor={doctor} avg_rating={avg_rating} />
              </div>

              <div className="col-lg-9 col-md-7">
                <Submit_Your_Review doctor={doctor} />
              </div>
              <div className="col-md-12">
                {all_rating && all_rating?.data?.length > 0 ? (
                  <Customer_Feedbacks doctor={doctor} all_rating={all_rating} />
                ) : (
                  <div className="text-center py-4 ">
                    <h6 className="text-secondary mb-0">
                      No customer reviews yet for this doctor.
                    </h6>
                    {/* <p className="text-muted small mt-1">
                      Be the first to share your feedback!
                    </p> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Doctor_Rating;
